import React from "react";
import { Globe } from "lucide-react";
import { useLang } from "@/context/SiteContentContext";

/**
 * Top page banner for language switching. Thin, premium strip above the navbar.
 */
export default function LanguageBanner() {
  const { lang, setLang } = useLang();

  return (
    <div
      data-testid="language-banner"
      className="fixed top-0 inset-x-0 z-[60] bg-slate-950 text-slate-200 border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-8 flex items-center justify-between text-[11px] tracking-[0.2em] uppercase font-display">
        <div className="flex items-center gap-2 opacity-70">
          <Globe size={11} />
          <span className="hidden sm:inline">Charles Lee · Kuala Lumpur</span>
        </div>
        <div className="flex items-center gap-1">
          <LangButton
            active={lang === "zh"}
            onClick={() => setLang("zh")}
            testId="lang-zh"
            label="中文"
          />
          <span className="opacity-30">/</span>
          <LangButton
            active={lang === "en"}
            onClick={() => setLang("en")}
            testId="lang-en"
            label="EN"
          />
        </div>
      </div>
    </div>
  );
}

function LangButton({ active, onClick, label, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      className={`px-2.5 py-1 rounded-sm transition-all ${
        active
          ? "text-orange-500 font-semibold"
          : "text-slate-400 hover:text-white"
      }`}
    >
      {label}
    </button>
  );
}
